import styled from 'styled-components';

export const StyledCardContainer = styled.div<{ $variant: string; $padding: string; $hoverable: boolean }>`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.borderRadius.lg};

  /* Variant styles */
  ${({ $variant, theme }) => {
    switch ($variant) {
      case 'outlined':
        return `
          border: 1px solid ${theme.colors.border};
          box-shadow: none;
        `;
      case 'filled':
        return `
          background: ${theme.colors.gray100};
          border: none;
          box-shadow: none;
        `;
      case 'compact':
        return `
          border: 1px solid ${theme.colors.borderSubtle};
          box-shadow: ${theme.shadows.sm};
        `;
      case 'elevated':
      default:
        return `
          border: 1px solid ${theme.colors.borderSubtle};
          box-shadow: ${theme.shadows.card};
        `;
    }
  }};

  /* Padding styles */
  padding: ${({ $padding, theme }) => {
    switch ($padding) {
      case 'sm':
        return theme.spacing[3];
      case 'lg':
        return theme.spacing[6];
      case 'md':
      default:
        return theme.spacing[4];
    }
  }};

  /* Hover state */
  transition: all 0.2s ease-in-out;

  ${({ $hoverable, theme }) =>
    $hoverable
      ? `
    &:hover {
      box-shadow: ${theme.shadows.cardHover};
      border-color: ${theme.colors.primary300};
    }
  `
      : ''}
`;

export const StyledPageContainer = styled.div<{ $maxWidth?: string }>`
  padding: ${({ theme }) => theme.spacing[6]};
  max-width: ${({ $maxWidth }) => $maxWidth || '1600px'};
  margin: 0 auto;

  @media (min-width: 1441px) {
    padding-right: calc(${({ theme }) => theme.spacing[6]} + 420px);
  }
`;

export const StyledFilterBar = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[3]};
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing[4]} ${theme.spacing[5]}`};
  background: ${({ theme }) => theme.colors.gray100};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  flex-wrap: wrap;
`;

export const StyledTabsContainer = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  box-shadow: ${({ theme }) => theme.shadows.card};
  overflow: hidden;
  margin-bottom: ${({ theme }) => theme.spacing[6]};
`;

export const StyledLayoutGrid = styled.div<{ $mainRatio: string; $sideRatio: string; $gap: string }>`
  display: grid;
  grid-template-columns: ${({ $mainRatio, $sideRatio }) =>
    `${$mainRatio} ${$sideRatio}`};
  gap: ${({ $gap }) => $gap};
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledLayoutMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[6]};
`;

export const StyledLayoutSide = styled.div<{ $top?: number }>`
  position: sticky;
  top: ${({ $top }) => ($top !== undefined ? `${$top}px` : '120px')};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[3]};

  @media (max-width: 1024px) {
    position: relative;
    top: 0;
  }
`;
